import { Select } from "antd";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import useAvailableDashboards from "../../hooks/useAvailableDashboards";
import trans from "../../utils";

const DashboardNavigator = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const availableDashboards = useAvailableDashboards();

	// Don't show if user has no dashboard permissions or only one dashboard

	// Determine current dashboard based on pathname
	// Only return dashboard keys that exist in availableDashboards
	const getCurrentDashboard = () => {
		const path = location.pathname;
		if (path.includes("/dashboard/fsm")) return "fsmDashboard";
		if (path.includes("/dashboard/consultant")) return "consultantDashboard";
		if (path.includes("/dashboard/qa")) return "qaDashboard";
		if (path === "/dashboard" || path === "/") return "dashboard";
		return null;
	};

	const currentDashboard = getCurrentDashboard();

	// Ensure currentDashboard is actually available to the user
	const isValidCurrentDashboard =
		currentDashboard &&
		availableDashboards.some((dash) => dash.key === currentDashboard);

	// Redirect to first available dashboard if current dashboard is not accessible
	useEffect(() => {
		if (
			currentDashboard &&
			!isValidCurrentDashboard &&
			availableDashboards.length > 0
		) {
			// User is on a dashboard they don't have access to, redirect to first available
			navigate(availableDashboards[0].path, { replace: true });
		}
	}, [
		currentDashboard,
		isValidCurrentDashboard,
		availableDashboards,
		navigate,
	]);
	if (availableDashboards.length <= 1) {
		return null;
	}

	const handleDashboardChange = (value) => {
		const selectedDashboard = availableDashboards.find(
			(dash) => dash.key === value,
		);
		// Only navigate if dashboard exists in available dashboards (user has permission)
		if (
			selectedDashboard &&
			availableDashboards.some((dash) => dash.key === value)
		) {
			navigate(selectedDashboard.path);
		}
	};

	const options = availableDashboards.map((dashboard) => ({
		label: dashboard.label,
		value: dashboard.key,
	}));

	// Only show value if it's in available dashboards and is valid
	const selectedValue = isValidCurrentDashboard ? currentDashboard : undefined;

	return (
		<Select
			value={selectedValue}
			onChange={handleDashboardChange}
			options={options}
			style={{ minWidth: 200 }}
			placeholder={trans("Select Dashboard")}
			className="dashboard-navigator"
		/>
	);
};

export default DashboardNavigator;
